// extracted by mini-css-extract-plugin
export var contrastLow = "_3c-1";
export var externalLink = "_3c-2";
export var externalLinkIcon = "_3c-3";
export var link = "_3c-0";
export var linkLabel = "_3c-4";